<mat-card appearance="outlined" class="cardBackground">
  <app-snackbar-content-layout>
    <app-snackbar-header-layout>
      <mat-card-title class="titleContainer">{{ "MAIN_APP_DASHBOARD.pendenteAufgaben" | translate }}</mat-card-title>
      <button
      mat-mini-fab
      color="primary"
      class="fabButton"
      (click)="closeSnackbar()">
      <mat-icon>cancel</mat-icon>
    </button>
    </app-snackbar-header-layout>
  </app-snackbar-content-layout>
  <mat-list *ngFor="let aufgabe of taskList">
    <mat-list-item class="listItem">
      <div matListItemTitle>{{aufgabe.title}}</div>
      <div matListItemTitle>{{ aufgabe.beschreibung }}</div>
      <div matListItemTitle>{{ "MAIN_APP_DASHBOARD.beginntAm" | translate }}:
        {{ formatDate(aufgabe.beginntAm) }}</div>
      <app-snackbar-header-layout>
        <div matListItemLine>{{ "MAIN_APP_DASHBOARD.fälligAm" | translate }}:
          {{ formatDate(aufgabe.faelligAm) }}</div>
        <button mat-mini-fab color="primary" (click)="showAufgabeDetail(aufgabe)" class="fabButton">
          <mat-icon>edit</mat-icon>
        </button>
      </app-snackbar-header-layout>
    </mat-list-item>
    <mat-divider></mat-divider>
    <div class="fabButtonContainer">
      <button mat-flat-button (click)="showAufgabenList()" class="flatButton">{{"MAIN_APP_DASHBOARD.alleAufgabenAnzeigen" | translate}}</button>
    </div> 
  </mat-list>
</mat-card>
